import { Drawer, LinearProgress } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { Button } from '../../../components/button/Button';
import { FlyoutFooter } from '../../../components/flyout-components/FlyoutFooter';
import { BackorderCommandResult } from '../models/backorder-command-result';
import { OrderingSvc } from '../service';

interface IProps {
    isOpen: boolean;
    onClose: any;
    orders: string;
}

export const BackorderStatusFlyout = (props : IProps) => {

    const [service]                            = React.useState(new OrderingSvc());
    const [orders, setOrders]                   = React.useState<BackorderCommandResult[]>([]);
    
    React.useEffect(() => {
        if (props.isOpen) {
            const orderCpy = cloneDeep(props.orders);
            processBackorders(orderCpy);
        }
    }, [props.isOpen]);

    const processBackorders = async (orderStr : string) => {

        const validIds : BackorderCommandResult[] = [];

        const ids = orderStr.split('\n');
        if (ids && ids.length > 0) {
            ids.forEach((itm : string) => {
                if (itm && itm.length > 0) {
                    const obj = new BackorderCommandResult();
                    obj.orderId = itm;
                    validIds.push(obj);
                }
            });

            setOrders(validIds);
        }
        
        for (let i = 0; i < validIds.length; i++) {

            validIds[i].isLoading = true;
            setOrders([...validIds]);
                
            const result = await service.backorderOrder(validIds[i].orderId);
            validIds[i].isLoading = false;
            validIds[i] = result.data;

            setOrders([...validIds]);
        }

    };

    const closeFlyout = () => {
        props.onClose();
    };

    const getTransportModuleStatus = (itm : BackorderCommandResult) => {
       if (itm.wasAttempted && !itm.error) {
            if (itm.removedFromPickupId || itm.removedFromDeliveryId) {
                return <i className="la la-check-circle success" />;
            }
            else {
                return <i className="la la-check-circle noop" />;
            }
        }
        else if (!itm.error && !itm.wasAttempted) {
            return <i className="la la-question-circle" />;
        }
        else {
            return <i className="la la-exclamation-circle error"/>;
        }
    };

    const getProductionModuleStatus = (itm : BackorderCommandResult) => {
        if (itm.wasAttempted && !itm.error) {
            if (itm.removedFromProductionRunId) {
                return <i className="la la-check-circle success" />;
            }
            else {
                return <i className="la la-check-circle noop" />;
            }
        }
        else if (!itm.error && !itm.wasAttempted) {
            return <i className="la la-question-circle" />;
        }
        else {
            return <i className="la la-exclamation-circle error"/>;
        }
    };

    const getBackorderAppStatus = (itm: BackorderCommandResult) => {
        if (itm.wasAttempted && !itm.error) {
            if (itm.sentToBackorderApp) {
                return <i className="la la-check-circle success" />;
            }
            else {
                return <i className="la la-exclamation-circle error" />;
            }
        }
        else if (!itm.error && !itm.wasAttempted) {
            return <i className="la la-question-circle" />;
        }
        else {
            return <i className="la la-exclamation-circle error" />;
        }
    };

    return (
        <Drawer
            anchor="right"
            onClose={ closeFlyout }
            open={props.isOpen}>
            <div className="stop-action-drawer large backorder-status-flyout">
                <div className="row">
                    <div className="col">
                        <h1>Order Progress</h1>
                    </div>
                </div>
                    
                <div className="row">
                    <div className="col">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">Order ID</th>
                                    <th className="text-center">Transportation Status</th>
                                    <th className="text-center">Production Status</th>
                                    <th className="text-center">Backorder App</th>
                                    <th className="text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    orders.map((itm : BackorderCommandResult, idx : number) => 
                                        <tr key={`order-row-${idx}`}>
                                            <td className="text-center">{ itm.orderId }</td>
                                            <td className="text-center">{ getTransportModuleStatus(itm) }</td>
                                            <td className="text-center">{ getProductionModuleStatus(itm) }</td>
                                            <td className="text-center">{ getBackorderAppStatus(itm) }</td>
                                            <td className="text-center">
                                                {
                                                    itm.isLoading
                                                        ? <LinearProgress
                                                            classes={{
                                                                colorPrimary: 'btn-progress-indicator-primary',
                                                                barColorPrimary: 'btn-progress-indicator-barcolor'
                                                            }} 
                                                        />
                                                        : itm.error                                                                    
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <FlyoutFooter>
                    <div className="row">
                        <div className="col">                            
                            <Button
                                text="Close"
                                classes="action"
                                testID="close-setdate-run-flyout"
                                onBtnClick={ closeFlyout } />
                        </div>
                    </div>
                </FlyoutFooter> 
                
            </div>
        </Drawer>
    );
};
